import { getWindow } from '../../utils/window.utils';

export class CurrencyService {
  private readonly _currencySymbol: string = '$';

  constructor() {
    if (getWindow().theme && !!getWindow().theme.moneyFormat) {
      this._currencySymbol = getWindow().theme.moneyFormat.split('{')[0];
      if (this._currencySymbol.indexOf('>') !== -1) {
        const div = document.createElement('div');
        div.innerHTML = this._currencySymbol;
        this._currencySymbol = div.innerText;
      }
    }
  }

  getSymbol(): string {
    return this._currencySymbol;
  }

  getCurrency(): string {
    return !getWindow().Shopify?.currency?.active ? 'USD' : getWindow().Shopify?.currency?.active;
  }

  formatMoney(cents, format = '{{amount}}'): string {
    return (
      this._currencySymbol +
      this.formatMoneyNoCurrency(cents, format) +
      ' ' +
      getWindow().Shopify?.currency?.active
    );
  }

  formatMoneyNoCurrency(cents, format = '{{amount}}'): string {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        return this.formatWithDelimiters(cents, 2);
      case 'amount_no_decimals':
        return this.formatWithDelimiters(cents, 0);
      case 'amount_with_comma_separator':
        return this.formatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return this.formatWithDelimiters(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return this.formatWithDelimiters(cents, 2, '.', "'");
      default:
        return this.formatWithDelimiters(cents, 2);
    }
  }

  private formatWithDelimiters(value, precision = 2, thousands = ',', decimal = '.'): string {
    if (isNaN(value) || value == null) {
      return '0';
    }

    const rate = getWindow().Shopify?.currency?.rate ? getWindow().Shopify.currency.rate : 1;
    value = (value / rate / 100.0).toFixed(precision);

    const parts = value.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }
}
